{
    "Number": "No",
    "Starttime": "Ora di inizio",
    "From": "Da",
    "To": "A",
    "Duration": "Durata",
    "NAME": "CallRecording"
}